import env from '../../../../config/environment'

class CepService extends AbstractService
  @$inject = [ '$http' ]

  constructor: (@$http) ->
    @apis =
      postmon: env.external_url + '/api.postmon.com.br/v1/cep/$CEP$'
      viaCep: env.external_url + '/viacep.com.br/ws/$CEP$/json/'

  buscarCep: (cep, callback, api = 'viaCep') ->
    cep = angular.copy cep.replace '-', ''
    
    @$http({
      method: 'GET',
      url: @apis[api].replace('$CEP$', cep),
      withCredentials: false
    }).then( (resp) =>
      if !resp.data.erro
        callback(new Retorno(true, null, resp.data))
      else
        callback(new Retorno(false, null, resp.data))

    ).catch( (resp) =>

      callback(new Retorno(false, null, resp.data))
    )

angular.module('eficienciaFiscalModule').service('cepService', CepService)
